<template>
    <div>
      <h2 class="text-2xl font-bold mb-4">🌿 Servicios Más Vendidos</h2>
  
      <div class="flex items-center gap-4 mb-4">
        <label>Desde:</label>
        <input type="date" v-model="desde" class="border p-2 rounded" />
        <label>Hasta:</label>
        <input type="date" v-model="hasta" class="border p-2 rounded" />
        <button @click="cargarServicios" class="bg-blue-600 text-white px-4 py-2 rounded">Buscar</button>
      </div>
  
      <table v-if="resumen.length" class="w-full text-sm border table-auto">
        <thead class="bg-gray-200">
          <tr>
            <th class="p-2 border">Servicio</th>
            <th class="p-2 border">Cantidad Vendida</th>
            <th class="p-2 border">Total Generado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="serv in resumen" :key="serv.id">
            <td class="p-2 border">{{ serv.nombre }}</td>
            <td class="p-2 border">{{ serv.cantidad }}</td>
            <td class="p-2 border font-bold">${{ serv.total.toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>
  
      <div v-else class="text-gray-500 mt-6">No hay servicios vendidos en este periodo.</div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { db } from '@/firebase'
  import { collection, query, where, getDocs, Timestamp } from 'firebase/firestore'
  
  const desde = ref('')
  const hasta = ref('')
  const resumen = ref([])
  
  const cargarServicios = async () => {
    if (!desde.value || !hasta.value) return alert('Selecciona las fechas')
  
    const desdeTS = Timestamp.fromDate(new Date(desde.value + 'T00:00:00'))
    const hastaTS = Timestamp.fromDate(new Date(hasta.value + 'T23:59:59'))
  
    const q = query(
      collection(db, 'ventas'),
      where('fecha', '>=', desdeTS),
      where('fecha', '<=', hastaTS)
    )
  
    const snap = await getDocs(q)
  
    const serviciosMap = {}
  
    snap.forEach(doc => {
      const venta = doc.data()
      if (venta.productos) {
        venta.productos.forEach(p => {
          if (p.tipo === 'servicio') {
            if (!serviciosMap[p.id]) {
              serviciosMap[p.id] = {
                id: p.id,
                nombre: p.nombre,
                cantidad: 0,
                total: 0
              }
            }
            serviciosMap[p.id].cantidad += p.cantidad
            serviciosMap[p.id].total += p.precio * p.cantidad
          }
        })
      }
    })
  
    resumen.value = Object.values(serviciosMap).sort((a, b) => b.cantidad - a.cantidad)
  }
  </script>
  